export default function Python_Data_Types() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">Python_Data_Types</h1>
      <p>Content for Python_Data_Types goes here.</p>
    </div>
  );
}